function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * done
 */

import { useField } from '@formily/react';
import { Cascader } from 'antd';
import cx from 'classnames';
import { isArray, isNil, isNumber } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { useClear, useCssInJs, useDict, useMessage, useParams, usePlaceholder, wrapReactionHook } from "../../hooks";
import { genDictArrayCascaderStyles } from "./styles";
export var DictArrayCascader = wrapReactionHook(function (props) {
  var message = useMessage();
  var defaultPlaceholder = usePlaceholder();
  var _props$autoClear = props.autoClear,
    autoClear = _props$autoClear === void 0 ? [] : _props$autoClear,
    dictType = props.dictType,
    dictMap = props.dictMap,
    onChange = props.onChange,
    value = props.value,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? defaultPlaceholder : _props$placeholder,
    _props$level = props.level,
    level = _props$level === void 0 ? 1 : _props$level,
    _props$childrenLoadLe = props.childrenLoadLevel,
    childrenLoadLevel = _props$childrenLoadLe === void 0 ? 5 : _props$childrenLoadLe,
    url = props.url,
    autoRemoveDict = props.autoRemoveDict,
    _props$params = props.params,
    params = _props$params === void 0 ? {} : _props$params,
    readOnly = props.readOnly,
    selectLimit = props.selectLimit,
    selectDepth = props.selectDepth,
    disabled = props.disabled,
    maxTagCount = props.maxTagCount;
  var prefix = 'form-dict-array-cascader';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genDictArrayCascaderStyles
    }),
    hashId = _useCssInJs.hashId,
    wrapSSR = _useCssInJs.wrapSSR;
  var clear = useClear(autoClear);
  var getParams = useParams(params);
  var field = useField();
  var enums = field && field.dataSource;
  var dictParams = {
    level: level,
    childrenLoadLevel: childrenLoadLevel,
    url: url,
    params: getParams(),
    autoRemoveDict: autoRemoveDict,
    dictMap: dictMap,
    enums: enums
  };
  var options = useDict(dictType, dictParams);
  var transformTree = useCallback(function (node) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var newNode = _objectSpread(_objectSpread({}, node), {}, {
      disableCheckbox: !(selectDepth !== null && selectDepth !== void 0 && selectDepth.includes(level))
    });
    if (node.children && node.children.length > 0) {
      newNode.children = node.children.map(function (child) {
        return transformTree(child, level + 1);
      });
    }
    return newNode;
  }, []);
  var transformOption = useMemo(function () {
    if (isNil(selectDepth) || !isArray(selectDepth)) {
      return options;
    }
    var optionArr = [];
    options.forEach(function (element) {
      optionArr.push(transformTree(element));
    });
    return optionArr;
  }, [options]);
  if (readOnly) {
    if (isArray(value) && (value === null || value === void 0 ? void 0 : value.length) === 0) {
      return '-';
    }
    return wrapSSR( /*#__PURE__*/React.createElement(Cascader, {
      disabled: true,
      options: transformOption,
      className: cx(prefix, hashId, 'readOnly'),
      value: value,
      multiple: true,
      maxTagCount: maxTagCount || 99
    }));
  }
  var handleChange = function handleChange(select) {
    if (isNumber(selectLimit) && (select === null || select === void 0 ? void 0 : select.length) > (value === null || value === void 0 ? void 0 : value.length) && (value === null || value === void 0 ? void 0 : value.length) >= selectLimit) {
      message.warning("\u6700\u591A\u9009\u62E9".concat(selectLimit, "\u9879"));
      return;
    }
    clear();
    onChange === null || onChange === void 0 || onChange(select);
  };
  return wrapSSR( /*#__PURE__*/React.createElement(Cascader, {
    disabled: disabled || readOnly,
    options: transformOption,
    className: cx(prefix, hashId),
    value: value,
    multiple: true,
    onChange: handleChange,
    placeholder: placeholder,
    maxTagCount: maxTagCount || 'responsive'
  }));
});